// extracted by mini-css-extract-plugin
module.exports = {"EditorTooltip":"EditorTooltip_EditorTooltip__dmpMm"};